import reducers from "./reducers";

import creditCardService from "./service";
import creditCardTypes from "./types";
import creditCardActions from "./actions";

export { creditCardService, creditCardActions, creditCardTypes };

export default reducers;
